import type { LineChartReportCardProps } from '../../AnalyticsDashboard.types'
import { useLineChartReportCard } from '../useLineChartReportCard'

const reportId = 'membership_free_accounts'

export const useMembershipsFreeAccountsReportCard = (): LineChartReportCardProps => {
  return useLineChartReportCard({
    reportId,
    headerLabel: 'Free accounts',
    headerTooltipTitle: 'Free accounts',
    headerTooltipDescription: 'Number of users with free accounts (inc. former members).',
  })
}
